<div
  [id]="'card-' + index"
  class="flex flex-col gap-4 p-4 bg-white rounded-lg shadow-cardLightShadow"
  [class.grid-card-size]="layout === searchResultLayoutEnum.Grid"
  [class.list-card-size]="layout === searchResultLayoutEnum.List"
>
  <div
    [id]="'card-header-' + index"
    class="flex flex-row items-center justify-start gap-2 grow-0"
  >
    <app-document-type-badge
      [documentType]="documentType"
      [name]="'document-type-' + index"
    ></app-document-type-badge>
    <span>&#x2219;</span>
    <span
      [id]="'document-status-' + index"
      class="body-small-regular text-disabled"
    >
      {{ documentStatus }}
    </span>
  </div>

  <div [id]="'card-body-' + index" class="flex flex-col justify-between grow">
    <a
      [id]="'card-title-' + index"
      class="truncate body-large-regular text-tertiary"
      [routerLink]="['/sa-library', getDocumentUri()]"

    >
      {{ searchResultItem?.designation | replaceHlgtTag }}
    </a>

    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-1">
        <span
          class="body-small-regular"
          [class.grid-line-clamp]="layout === searchResultLayoutEnum.Grid"
          [class.list-line-clamp]="layout === searchResultLayoutEnum.List"
          [appTooltip]="searchResultItem?.title | replaceHlgtTag"

        >
          {{ searchResultItem?.title | replaceHlgtTag }}
        </span>
        <div class="flex flex-row items-end justify-between">
          <span class="body-small-regular text-disabled">
            Committee: {{ searchResultItem?.committee | replaceHlgtTag }} <br />
            Published: {{ searchResultItem?.pubDate | dateFormat }}
          </span>

          <app-sa-library-download *ngIf="searchResultItem" [uri] = 'uri' [index] = 'index' [fromDocumentSearch] = "true"></app-sa-library-download>
        </div>

      </div>
    </div>
  </div>
</div>
